module.exports = __webpack_public_path__ + "img/T1A_rc_12.160dfec4.png";